// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"DevicePage_overlayWrapper__Jb45k"};